var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_860_1715)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58ZM16.4926 14.0664C15.8315 14.0664 15.1974 14.3283 14.7296 14.7945C14.2624 15.2613 14 15.8941 14 16.5538C14 17.2135 14.2624 17.8463 14.7296 18.3131L25.4407 29.0017L14.7296 39.6903C14.2884 40.1621 14.048 40.7865 14.0592 41.4318C14.0704 42.077 14.3322 42.6928 14.7895 43.1491C15.2468 43.6054 15.8638 43.8667 16.5105 43.8779C17.1571 43.889 17.7828 43.6492 18.2556 43.2089L28.9667 32.5203L39.6778 43.2089C39.9832 43.5355 40.371 43.774 40.8006 43.8996C41.2302 44.0252 41.6857 44.0331 42.1194 43.9225C42.5539 43.8129 42.9507 43.5883 43.268 43.2725C43.5853 42.9567 43.8113 42.5613 43.9223 42.1281C44.0334 41.6948 44.0252 41.2397 43.8988 40.8106C43.7723 40.3816 43.5322 39.9946 43.2038 39.6903L32.4927 29.0017L43.2038 18.3131C43.5311 18.0084 43.7702 17.6213 43.896 17.1927C44.0219 16.764 44.0298 16.3094 43.919 15.8766C43.8091 15.4431 43.5841 15.0471 43.2676 14.7305C42.9511 14.4139 42.5549 14.1883 42.1208 14.0775C41.6866 13.9667 41.2305 13.9748 40.8006 14.101C40.3706 14.2272 39.9828 14.4668 39.6778 14.7945L28.9667 25.4831L18.2556 14.7945C17.7879 14.3283 17.1538 14.0664 16.4926 14.0664Z",
    fill: "#535353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_860_1715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoreview);
export default __webpack_public_path__ + "static/media/noreview.2b6470289019e0c2a4e8c99558844cc1.svg";
export { ForwardRef as ReactComponent };